"use strict";

exports.__esModule = true;
exports.BM_EXPERIMENTS = void 0;
const BM_EXPERIMENTS = exports.BM_EXPERIMENTS = {
  MOTO: 'specs.membership.EnableMoto',
  DASHBOARD_CONTENT_UPDATES: 'specs.membership.DashboardContentUpdates',
  WORKAROUND_BENEFITS_FLICKER: 'specs.membership.WorkaroundBenefitsFlicker',
  CAIRO_TABLE: 'specs.membership.CairoTable',
  REMOVE_ANALYTICS: 'specs.membership.RemoveAnalyticsWithNoPlansSold',
  NEW_PRICE_LIMIT: 'specs.membership.NewPriceLimit',
  TYP_URL_VALIDATION: 'specs.membership.TypUrlValidation',
  TAX_NAME: 'specs.membership.TaxNameInBM',
  SHOW_BENEFIT_EXTENSIONS: 'specs.membership.showBenefitExtensions',
  UPDATE_PLAN_DURATION_OPTION: 'specs.membership.UpdatePlanDurationOptions',
  SUPPORT_DEALER_DYNAMIC_PARAMS: 'specs.membership.SupportDealerDynamicParams',
  UPDATED_TAX_DISCLAIMER: 'specs.membership.UpdatedTaxDisclaimer',
  GIZA_PAGES_IN_BM: 'specs.membership.GizaPagesInBm',
  TAX_BREAKDOWN_CURRENCY: 'specs.membership.TaxBreakdownCurrencyFromSettings',
  DEV_CENTER_FORM_CONFIGURATION: 'specs.membership.DevCenterFormConfiguration',
  FORM_COMPOSER_ADD_PANEL: 'specs.membership.FromComposerAddPanel',
  FORM_COMPOSER_BIRTHDATE_FIELD: 'specs.membership.FormComposerBirthdateField',
  FORM_COMPOSER_FILE_UPLOAD_FIELD: 'specs.membership.FormComposerFileUploadField',
  FORM_COMPOSER_CONTACT_FIELDS: 'specs.membership.FormComposerContactFields',
  FORM_COMPOSER_DATE_FIELDS: 'specs.membership.FormComposerDateFields',
  DO_NOT_AWAIT_PAYMENT_INFO: 'specs.membership.DontAwaitPaymentsInfo',
  BENEFIT_PROGRAMS: 'specs.membership.BenefitsPrograms',
  BENEFIT_PROGRAMS_COMPONENTS: 'specs.membership.BenefitsProgramsComponents',
  BOOKINGS_BENEFIT_PROGRAMS_DEMO: 'specs.membership.BookingsBenefitProgramsDemo',
  AI_ASSISTANT: 'specs.membership.PricingPlansAssistantEntryPoint',
  PLAN_DESCRIPTION_200: 'specs.membership.PlanDescription200',
  INVOICES_DISCLAIMER: 'specs.membership.InvoicesDisclaimer',
  CURRENCY_MISMATCH_DISCLAIMER: 'specs.membership.CurrencyMismatchDisclaimer'
};
//# sourceMappingURL=bm.js.map